import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import PageLayout from '../../components/PageLayout';
import { campusSelector, selectedSchoolSelector } from '../../reducers/selectors';

const FrenchRegulationBlockPage = ({ selectedCampus, selectedSchool }) => {
  const { label: schoolName } = selectedSchool;
  const campusName = selectedCampus ? selectedCampus.label : '';
  const isInseadCampus = selectedCampus && schoolName === 'INSEAD';

  const { REACT_APP_PLATFORM_DASHBOARD: PLATFORM_DASHBOARD_URL } = process.env;

  const pageTitle = isInseadCampus
    ? `We're currently unable to support ${schoolName}'s ${campusName} campus`
    : `We're currently unable to support ${schoolName}`;

  const endOfSentence = isInseadCampus
    ? `at the ${campusName} campus of the institution. We continue to support courses offered at the Singapore campus.`
    : 'at this institution.';

  const option = isInseadCampus ? 'campus' : 'school';

  return (
    <PageLayout title={pageTitle}>
      <div className="row-spacer">
        <p>
          {`Due to French regulatory constraints, we are unable to support courses ${endOfSentence}`}
        </p>
      </div>
      <div className="row-spacer">
        <p>{`Please check back for further updates or go back and choose another ${option}.`}</p>
      </div>
      <div className="row">
        <div className="col col--auto">
          <a href={`${PLATFORM_DASHBOARD_URL}`} className="link-button link-button--inverted">
            Go to dashboard
          </a>
        </div>
      </div>
    </PageLayout>
  );
};

FrenchRegulationBlockPage.propTypes = {
  selectedCampus: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  selectedSchool: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
};

export const mapStateToProps = reduxStore => ({
  selectedCampus: campusSelector(reduxStore),
  selectedSchool: selectedSchoolSelector(reduxStore),
});

export { FrenchRegulationBlockPage };

export default connect(mapStateToProps, null)(FrenchRegulationBlockPage);
